import { useMutation } from '@tanstack/react-query';
import { activeFreeTrial } from '../../services/subscriptions';
import { useTokens } from '../auth/useTokens';

const useActivateFreeTrial = () => {
  const authDetails = useTokens.getState();
  return useMutation({
    mutationKey: ['activate-free-trial'],
    mutationFn: () =>
      activeFreeTrial({
        userIdBw: authDetails.userInfo.username,
        clientId: authDetails.userInfo.broker,
      }),
  });
};

export default useActivateFreeTrial;
